import { SupportAppWindow } from '../../../Apps/Models/SupportAppWindow';
import { getCookieValue, GetNewGuid } from '../../../Utilities/Helpers';

const VNextCorrelationIdKey = 'CorrelationId';
const VNextSessionId = 'Session-Id';
const FDType = 'FDType';
const MPFDType = 'multiportal';

export class AppSessionContext {
  public static instance: AppSessionContext;

  private correlationId: string | undefined;
  private sessionId: string | undefined;
  private isMP: boolean | undefined;
  private ticketTrackingId: string | undefined;

  public static getInstance = () => {
    if (!AppSessionContext.instance) {
      AppSessionContext.instance = new AppSessionContext();
    }
    return AppSessionContext.instance;
  };

  get CorrelationId() {
    if (!this.correlationId) {
      this.correlationId = getCookieValue(VNextCorrelationIdKey);
    }
    return this.correlationId;
  }

  get Locale() {
    return ((window as any).Support as SupportAppWindow).locale;
  }

  get AppConfig() {
    return ((window as any).Support as SupportAppWindow).appSettings.apiConfig;
  }

  get TelemetryConfig() {
    return ((window as any).Support as SupportAppWindow).appSettings.telemetryConfig;
  }

  get RedirectionConfig() {
    return ((window as any).Support as SupportAppWindow).appSettings.redirectionConfig;
  }

  get VirtualDirectoryRoot() {
    return ((window as any).Support as SupportAppWindow).appSettings.virtualDirectoryRoot;
  }

  get HostName() {
    return ((window as any).Support as SupportAppWindow).appSettings.hostName;
  }

  get BuildId() {
    return ((window as any).Support as SupportAppWindow).buildId;
  }

  get SessionId() {
    if (!this.sessionId) {
      this.sessionId = getCookieValue(VNextSessionId);
    }

    return this.sessionId;
  }

  get TicketTrackingId() {
    if (!this.ticketTrackingId) {
      this.ticketTrackingId = GetNewGuid();
    }
    return this.ticketTrackingId;
  }

  set TicketTrackingId(id: string) {
    this.ticketTrackingId = id;
  }

  public resetTicketTrackingId() {
    this.ticketTrackingId = GetNewGuid();
  }

  get IsMP() {
    if (!this.isMP) {
      this.isMP = getCookieValue(FDType) === MPFDType;
    }

    return this.isMP;
  }
}
